.search-field__input-wrapper {
  display: flex;
  justify-content: flex-end;
  position: relative;
  width: 100%;
}

.search-field__input-field {
  appearance: none;
  background-color: var(--color-uva-white);
  border: 1px solid var(--color-grey-400);
  border-radius: 0.25rem;
  color: var(--color-uva-black);
  flex: 1;
  font-family: inherit;
  font-size: inherit;
  height: 2.35rem;
  margin: 0;
  padding: 0 2.75rem 0 1rem;
  text-align: inherit;
  width: 100%;
}

.search-field__input-field::placeholder {
  color: var(--color-grey-700);
  font-size: inherit;
  opacity: 1;
}

.search-field__input-field:focus-visible {
  background-color: var(--color-grey-300);
  outline: 1px solid var(--color-grey-700);
}

.search-field__icon {
  color: var(--color-grey-700);
  position: absolute;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
}

.search-field__result-wrapper {
  background-color: var(--color-uva-white);
  border: 1px solid var(--color-grey-700);
  border-radius: 0.25rem;
  display: flex;
  flex-direction: column;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: calc(100% + 0.25rem);
  width: clamp(22rem, 100%, 24rem);
  z-index: 10;
}

.search-field__input-container {
  position: relative;
  width: 100%;
}

.search-field__input-container--hidden {
  display: none;
}

.search-field__input-container--visible {
  display: block;
  max-width: 22rem;
  min-width: 100%;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 10;
}

.search-field__compact-button {
  align-items: center;
  appearance: none;
  background-color: transparent;
  background-color: var(--color-uva-white);
  border: 1px solid var(--color-grey-400);
  border-radius: 0.25rem;
  color: var(--color-uva-black);
  cursor: pointer;
  display: flex;
  height: 2.35rem;
  justify-content: center;
  margin: 0;
  text-align: inherit;
  width: 2.35rem;
}

.search-field__compact-icon {
  color: var(--color-grey-700);
}

.search-field__result-list {
  border-bottom: 1px solid var(--color-grey-700);
  list-style: none;
  margin: 0;
  max-height: min(23.75rem, 50vh);
  overflow-y: auto;
  padding: 0;
}

.search-field__result-list:empty {
  display: none;
}

.search-field__result-item {
  font-size: inherit;
  max-width: 100%;
  padding: 0.5rem 1rem;
  white-space: nowrap;
}

.search-field__result-item:focus-visible {
  background-color: var(--color-grey-300);
  outline: none;
}

.search-field__result-item:hover,
.search-field__result-item:focus-visible {
  background-color: var(--color-grey-300);
  cursor: pointer;
}

.search-field__result-info {
  background-color: var(--color-uva-white);
  border-radius: 0 0 0.25rem 0.25rem;
  border-top: 1px solid var(--color-grey-400);
  font-size: inherit;
  max-width: 100%;
  padding: 0.5rem 1rem;
  white-space: nowrap;
}
